export const FETCH_ACTIVITIES = 'FETCH_ACTIVITIES'
export const FETCH_ACTIVITIES_SUCCESS = 'FETCH_ACTIVITIES_SUCCESS'
export const FETCH_ACTIVITIES_ERROR = 'FETCH_ACTIVITIES_ERROR'